import { CoreTypography } from '@youscience/core';
import { CardAreaOfStudy } from '@common-types';

import { AreaProgramsAccordion } from '@components/AreaProgramsAccordion';
import { Container } from '@components/Layout/components/Container';

import { sxStyles } from './AreasOfStudySection.styles';

interface AreasOfStudySectionProps {
  areas: CardAreaOfStudy[];
}

export const AreasOfStudySection = (props: AreasOfStudySectionProps) => {
  const { areas } = props;

  return (
    <Container>
      <CoreTypography sx={sxStyles.title} variant="h3" component="h2">
        Areas of study and programs offered
      </CoreTypography>

      {areas?.map((area) => {
        const areaPrograms = area.cipCodes.map((item) => +item.cipCode);

        return (
          <AreaProgramsAccordion
            key={area.areaOfStudyDescription}
            areaTitle={area.areaOfStudyDescription}
            areaCipCode={+area.areaOfStudy}
            areaPrograms={areaPrograms}
          />
        );
      })}
    </Container>
  );
};
